import { formatIntNumber } from '../../../shared/helpers/WVFormatter';

export default ({ property, record }) => (record.params[property.name] || record.params[property.name] === 0 ? formatIntNumber(record.params[property.name]) : '');
